// CompanyComponent.jsx
import React, { useState } from 'react';
import { Switch } from 'antd';

function CompanyComponent({
  company,
  currentCompany,
  handleAddCompany,
  handleRemoveCompany,
  companyToggleStar,
  clearAllCompany,
  setCurrentCompany,
}) {
  const [toggle, setToggle] = useState(false);
  const toggler = () => {
    setToggle(!toggle);
  };

  return (
    <div className="mb-4 mt-6">
      <div className="flex justify-between items-center flex-col sm:flex-row">
        <label className="block text-gray-700 font-bold">Company</label>
        <div className="flex items-center">
          <Switch onClick={toggler} />
          {toggle ? <span> Boolean On </span> : <span>Boolean Off</span>}
        </div>
      </div>


      {/* Company Input */}
      <div className="relative flex items-center">
        <input
          type="text"
          value={currentCompany}
          onChange={(e) => setCurrentCompany(e.target.value)}
          onKeyDown={handleAddCompany}
          placeholder="(LTS OR 'TCS') AND Amazon AND Accenture"
          className="w-full border rounded-md py-2 px-3 text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-500 mt-2"
        />

        {/* Clear All Button */}
        {company.length > 0 && (
          <button
            type="button"
            onClick={clearAllCompany}
            className="absolute right-2 text-blue-500 hover:text-blue-700 mt-2"
          >
            Clear All
          </button>
        )}
      </div>

      {/* Company Tags with Star Toggle */}
      <div className="flex flex-wrap mt-2 mb-2 space-x-2 space-y-2">
        {company.map((company, index) => (
          <div
            key={index}
            className="flex items-center bg-blue-100 text-blue-700 py-1 px-2 rounded-full"
          >
            {/* Star Icon */}
            <button
              type="button"
              className={`mr-2 ${company.isStarred ? "text-yellow-500" : "text-gray-500"}`}
              onClick={() => companyToggleStar(index)}
            >
              {company.isStarred ? "★" : "☆"}
            </button>

            {/* company Text */}
            <span>{company.text}</span>

            {/* Remove Button */}
            <button
              type="button"
              className="ml-2 text-blue-700 hover:text-blue-900"
              onClick={() => handleRemoveCompany(company.text)}
            >
              &times;
            </button>
          </div>
        ))}
      </div>

      <label className="inline-flex items-center mt-2">
        <input type="checkbox" className="form-checkbox" />
        <span className="ml-2">Mark all companies as mandatory</span>
      </label>
    </div>
  );
}

export default CompanyComponent;
